import { type TagItemData } from '@app/components/LeadCard/data';
import { Tag } from '@app/shared/ui/Tag';

import type { FC } from 'react';

import './UserTags.scss';

interface UserTagsProps {
  items: TagItemData[];
  isEditable?: boolean;
  onEdit?: () => void;
}

export const UserTags: FC<UserTagsProps> = ({ items }) => {
  const hasTags = items.length > 0;

  return (
    <section className="UserTags">
      <div className="UserTags__header">
        <h4 className="UserTags__title">Теги</h4>
      </div>
      {hasTags ? (
        <div className="UserTags__list">
          {items.map((item) => (
            <Tag className="UserTags__tag" item={item} key={item.id} />
          ))}
        </div>
      ) : (
        <p className="UserTags__empty">Нет тегов</p>
      )}
    </section>
  );
};
